import { IAccount, paths } from 'shopify-payment-core'

import { useFirebase } from '../atoms/Firebase'

export function useAccountRef(account: IAccount) {
  const { ref } = useFirebase()
  return ref(paths[account.segmentKey].getAccount(account.id))
}
